import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useDialog } from '../context/DialogContext';
import '../styles/LoginPage.css';

function RegisterPage() {
  const dialog = useDialog();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await fetch('/api/users/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
          first_name: firstName, 
          last_name: lastName, 
          email, 
          password 
        })
      });
      const data = await response.json();

      if (!response.ok) {
        setError(data.message || 'Błąd podczas rejestracji');
      } else {
        await dialog.alert('Rejestracja zakończona powodzeniem!', { title: 'Sukces' });
        navigate('/login');
      }
    } catch (err) {
      setError('Błąd sieciowy.');
    }
  };

  return (
    <div className="main">
      <h2>Rejestracja</h2>
      <form onSubmit={handleRegister}>
        <div>
          <label>Imię: </label>
          <input 
            type="text" 
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required 
          />
        </div>
        <div>
          <label>Nazwisko: </label>
          <input 
            type="text" 
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required 
          />
        </div>
        <div>
          <label>Email: </label>
          <input 
            type="email" 
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required 
          />
        </div>
        <div>
          <label>Hasło: </label>
          <input 
            type="password" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required 
          />
        </div>
        {error && <p style={{ color: 'red' }}>{error}</p>}
        <button type="submit" className="btn-primary">Zarejestruj się</button>
      </form>
      <p>Masz już konto? <Link to="/login">Zaloguj się</Link></p>
    </div>
  );
}

export default RegisterPage;
